var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A error fallback component for ErrorBoundary when Compass fails to connect to an MFE
 *
 * @param error
 * @returns
 */
import { useEffect } from 'react';
import { Flex, Icon, InfoOutlineIcon, Text } from 'shared/components/ui';
import { useErrorToast } from 'shared/hooks/useErrorToast';
export var ErrorFallback = function (_a) {
    var error = _a.error;
    var errorToast = useErrorToast();
    useEffect(function () {
        errorToast(error);
    }, [error]);
    return (_jsxs(Flex, __assign({ display: "inline-flex", rounded: "md", color: "info.text", bgColor: "info.light", p: "3", my: "3" }, { children: [_jsx(Icon, { fontWeight: "bold", mr: "16px", fontSize: "xl", as: InfoOutlineIcon }), _jsx(Text, __assign({ fontWeight: "bold" }, { children: "Unable to load page." }))] })));
};
